module.exports = __webpack_public_path__ + "assets/img/00102.cafea36d.png";